import React, { useState } from 'react'
import { animated, config, Transition } from 'react-spring'
import { Waypoint } from 'react-waypoint'

interface Props {
  figCaption?: string
  imgSrc: string
  type: number
}

export const TypescriptComponent = ({ figCaption, imgSrc, type }: Props) => {
  const [showImage, setShowImage] = useState(false)

  return (
    <Waypoint
      bottomOffset='200px'
      onEnter={() => {
        setShowImage(true)
      }}
    >
      <figure className={`gallery__item gallery__item--${type}`}>
        <Transition
          items={showImage}
          from={{ opacity: 0, y: 0 }}
          enter={{ opacity: 1, y: 1 }}
          leave={{ opacity: 0, y: 0 }}
          delay={200}
          config={{ ...config.slow, friction: 150 }}
        >
          {({ opacity, y }, item) =>
            item ? (
              <>
                <animated.img
                  style={{
                    transform: y
                      .to({
                        range: [0.0, 1.0],
                        output: [60, 0]
                      })
                      .to(y => `translate3d(0,${y}px,0)`),
                    opacity: opacity.to({
                      range: [0.0, 1.0],
                      output: [0, 1]
                    })
                  }}
                  className='gallery__img'
                  src={imgSrc}
                />
                {figCaption && <figcaption>{figCaption}</figcaption>}
              </>
            ) : (
              <div />
            )
          }
        </Transition>
      </figure>
    </Waypoint>
  )
}
